var map = {
	"./KitaseoCovidAlcaldesa.mp3": 376,
	"./SopravalCajasAlcaldesa.mp3": 377,
	"./SopravalCajasLucas.mp3": 378,
	"./ViviendasAlcaldesa.mp3": 379,
	"./aljibesAlcaldesa.mp3": 380,
	"./aljibesCamila.mp3": 381,
	"./aljibesCore.mp3": 382,
	"./aljibesIntendente.mp3": 383,
	"./aljibesPercy.mp3": 384,
	"./aportesPropiosAlcaldesa.mp3": 385,
	"./aportesPropiosBenito.mp3": 386,
	"./censoComunalAlcaldesa.mp3": 387,
	"./entregapapasalcaldesa.mp3": 388,
	"./entregarinju.mp3": 389,
	"./entregarinjualcaldesa.mp3": 390,
	"./entregarinjuseremi.mp3": 391,
	"./hospitalAlcaldesa.mp3": 392,
	"./patentesBorbaran.mp3": 393,
	"./viviendasPiraino.mp3": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;